//import axios from "axios";
import { defineStore } from 'pinia';
import {router} from "@/router";
import {  ref } from 'vue';
export const useAuthStore = defineStore(
  'auth',
  () => {
    const user = ref('');
    const data = ref('');
    const token = ref('');
    const name = ref('');
    const returnUrl = ref(null);

    function setUserToken(newValue) {
      token.value = newValue;
      console.log('Setting user token:', newValue);
    }

    function setUser(newValue) {
      user.value = newValue;
    }

    function setData(newValue) {
      data.value = newValue;
    }

    function setName(firstname, lastname) {
      name.value = firstname + ' ' + lastname;
    }

    async function logout() {
      console.log('Logging out user:', user.value);
      user.value = null;
      token.value = null;
      data.value = null;
      name.value = null;
      router.push('/login');
    }

    return { user, data, token, name, returnUrl, setUserToken, setUser, setData, setName, logout };
  },{
  persist: true,

});
